import { combineReducers } from "@reduxjs/toolkit";
import applicationsSearchSlice from "./applicationsSearch/applicationsSearchSlice";
import aviationFormSlice from "./aviationForm/aviationFormSlice";
import { baseApi } from "./baseApi";
import dashboardSlice from "./dashboard/dashboardSlice";
import downloadsSlice from "./downloads/downloadsSlice";
import notificationsSlice from "./notifications/notificationsSlice";
import userSlice from "./user/userSlice";
import quotesSlice from "./quotes/quotesSlice";
import signatureSlice from "./signature/signatureSlice";
import renewalsSearchSlice from "./renewalsSearch/renewalsSearchSlice";
import emailTemplatesSlice from "./emailTemplates/emailTemplatesSlice";

function createRootReducer() {
  const appReducer = combineReducers({
    signature: signatureSlice,
    quotes: quotesSlice,
    user: userSlice,
    aviationForm: aviationFormSlice,
    notifications: notificationsSlice,
    downloads: downloadsSlice,
    applicationsSearch: applicationsSearchSlice,
    dashboard: dashboardSlice,
    renewalsSearch: renewalsSearchSlice,
    emailTemplates: emailTemplatesSlice,
    [baseApi.reducerPath]: baseApi.reducer,
  });

  const rootReducer = (state, action) => {
    if (action.type === "ERASE_REDUX_STORE") {
      return appReducer(undefined, action);
    }

    return appReducer(state, action);
  };

  return rootReducer;
}
export default createRootReducer;
